export default function Calendar() {
  return (
    <div style={{ padding: '1rem' }}>
    <h1>Calendar</h1>
    </div>
  );
}